import VueCompositionAPI from '@vue/composition-api'
import { BootFileParams } from '@niknevis/vue-modules/types'

export default function({ Vue }: BootFileParams) {
  Vue.use(VueCompositionAPI)
}
